import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getFormData,
  getFormUploads,
  updateFormField,
} from 'store/forms/actions';
import { TabsTimeline, FormFooter } from 'components';
import { isNil } from 'lodash';
import { checkUser, checkUserLogged, getUser , getTaxisData} from 'store/user/actions';
import { getMainformDetails, kadBranchesService, checkUniqueness } from 'store/forms/actions';
import { stepsForeignSupplier } from './stepsForeignSupplier';
import { useNavigate } from 'react-router-dom';
import { isBeneficiary, isForeign, handleCheckUniqueness } from '../../../utils';

import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';
import { useSupplierType } from 'hooks/useSupplierType';

const MainFormsForeignSupplier = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  // const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const carrier = useSelector(state => state.forms.carrier);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const auditorComment = useSelector(state => state.forms?.auditor?.auditorComment);
  const objectionCommitteeComment = useSelector(state => state.forms?.objection?.objectionCommitteeComment);
  const objCommentBen = useSelector(state => state.forms.carrier.objCommentBen);
  const loadingPage = useSelector(state=>state.user.loading);
  const [loadingPageVar, setLoadingPageVar] = useState(true);
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  const currentDate = new Date().toISOString().split('T')[0];
  const activeTaskName = useSelector(state => state.forms.activeTaskName);

  useEffect(() => {
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(getFormData(params.taskId));
    dispatch(getFormUploads(params.taskId));
    if(window.location.pathname.includes('view')){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true
           
        })
      );
    }
  }, [dispatch, params.taskId]);

    useEffect(() => {
    if(viewMode || (( activeTaskName && activeTaskName !== "task.name.submit_application"))){
      if(!isEmpty(task?.processInstanceId)){
        dispatch(getMainformDetails(task?.processInstanceId));
      }
    }
    }, [task?.processInstanceId, activeTaskName]);

  useEffect(()=>{
    if(!isNil(loadingPage)){
      setLoadingPageVar(loadingPage);
    }
  },[loadingPage]);

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set current step based on user and Status
  useEffect(() => {
    if (!stepsForeignSupplier) return;

    if (isBeneficiary(user?.groups)) {
      if (activeTaskName === 'task.name.temporary_rejected') {
        setCurrent(6);
      } else {
        setCurrent(0);
      }
    } else {
      setCurrent(0);
    }
  }, [activeTaskName, user?.groups, stepsForeignSupplier]);

    useEffect(() => {
      if (carrier?.abiVat) {
        handleCheckUniqueness({
          user,
          isForeign,
          carrier,
          dispatch,
          checkUniqueness,
        }).then(res => {
          console.log('res: ', res)
          dispatch(
            updateFormField({
              group: 'checkUniquenessCreate',
              key: 'acceptableDate',
              value: res.acceptableDate,
            })
          );
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isForeign, carrier?.abiVat]);


  return (
    loadingPageVar ?
    <div
      style={{
        position:"absolute",
        left:"50%",
        top:"50%"
      }}
    >
      <Spin size="large" />
    </div> 
    :
    <div id="mainforms-page-1" className="investor-form-container">

     {!isNil(current) && 
     <div className="investor-steps-footer-container">
      <TabsTimeline 
          tabs={stepsForeignSupplier({ activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment })}
          current={current} 
          setCurrent={setCurrent} 
          customClass={`custom-tabs-timeline active-tab-${current+1}`}
      />
      <FormFooter 
          tabs={stepsForeignSupplier({ activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment })}
          current={current} 
          setCurrent={setCurrent} 
          currentSubTab={currentSubTab} />
      </div>
      }
    </div>
  );
};

export default MainFormsForeignSupplier;
